"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETypePersonneJuridique = void 0;
exports.ETypePersonneJuridique = {
    personne_physique: "personne_physique",
    personne_morale: "personne_morale",
};
